<div class="dropdown">
  <!-- Show message with link to settings when no work order items are configured -->
  <div *ngIf="isWorkOrderItemsField && outputChoices.length === 0" class="empty-choices-message">
    <span i18n>Ni nastavljenih opravil.</span>
    <a href="/admin/settings/administration/work-order-items" target="_blank" class="settings-link" i18n>
      Dodaj v nastavitvah <i class="fas fa-external-link-alt ml-1"></i>
    </a>
  </div>

  @if (searchable) {
    <app-searchable-select [options]="searchOptions"
                           [value]="selectedKey"
                           [invalid]="control.invalid"
                           [disabled]="control.disabled"
                           [clearable]="field.config.allowNull !== false || !field.config.hasOwnProperty('allowNull')"
                           [dataField]="field?.fieldUuid"
                           [dataTypeId]="field?.config?.typeId"
                           [ariaLabel]="field?.config?.label"
                           (valueChange)="onSearchSelected($event)"></app-searchable-select>
  } @else {
    <select *ngIf="!isWorkOrderItemsField || outputChoices.length > 0"
            [formControl]="control" [compareWith]="sameChoice" autocomplete="off" [ngClass]="{'input-error': control.invalid }"
            [attr.data-field]="field?.fieldUuid"
            [attr.data-typeId]="field?.config?.typeId" [attr.aria-label]="field?.config?.label" [attr.tabIndex]="0">
      <option value="" *ngIf="field.config.allowNull !== false || !field.config.hasOwnProperty('allowNull')"></option>

      <option *ngFor="let optionValue of outputChoices"
              [disabled]="optionValue?.disabled"
              [ngValue]="optionValue">{{ optionValue | firstvalue }}
      </option>
    </select>
  }
</div>
